import { Pipe, PipeTransform } from '@angular/core';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { escapeRegex } from '@ddv/utils';

@Pipe({
    name: 'highlight',
    standalone: false,
})
export class Highlight implements PipeTransform {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/explicit-module-boundary-types
    transform(value: any, args?: string): string {
        if (args) {
            const re = new RegExp(escapeRegex(args), 'gi');
            return `${value}`.replace(re, (match) => `<mark>${match}</mark>`);
        }
        return value;
    }
}
